/* tslint:disable */
/* eslint-disable */
/**
 * Alobacsi API
 * The Alobacsi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpecialistModify
 */
export interface SpecialistModify {
    /**
     * 
     * @type {string}
     * @memberof SpecialistModify
     */
    name: string;
    /**
     * icon filename+ext
     * @type {string}
     * @memberof SpecialistModify
     */
    iconName: string;
}

/**
 * Check if a given object implements the SpecialistModify interface.
 */
export function instanceOfSpecialistModify(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "iconName" in value;

    return isInstance;
}

export function SpecialistModifyFromJSON(json: any): SpecialistModify {
    return SpecialistModifyFromJSONTyped(json, false);
}

export function SpecialistModifyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecialistModify {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'iconName': json['iconName'],
    };
}

export function SpecialistModifyToJSON(value?: SpecialistModify | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'iconName': value.iconName,
    };
}

